import { type FC } from 'react';

import { Link } from 'react-router-dom';

import { COMPANY } from '@shared/config';

// Политика по ст. 18.1 152-ФЗ. Один текст для страницы /privacy и окна из формы.
// Рабочая редакция: перед боевым запуском проверить юристу; при правке — поднять PD_DOCS_VERSION
export const PrivacyText: FC = () => (
  <>
    <h2>1. Общие положения</h2>
    <p>
      Политика определяет порядок обработки и защиты персональных данных посетителей сайта{' '}
      {COMPANY.site} (далее — Сайт) в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О
      персональных данных».
    </p>
    <p>
      Оператор персональных данных — <strong>{COMPANY.operator}</strong>, ОГРНИП {COMPANY.ogrnip},
      ИНН {COMPANY.inn}, адрес: {COMPANY.address}, e-mail:{' '}
      <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>, телефон: {COMPANY.phone} (далее —
      Оператор).
    </p>

    <h2>2. Какие данные обрабатываются</h2>
    <p>При запросе коммерческого предложения посетитель указывает:</p>
    <ul>
      <li>имя;</li>
      <li>наименование организации (по желанию);</li>
      <li>номер телефона или адрес электронной почты;</li>
      <li>текст обращения (по желанию);</li>
      <li>
        приложенные к обращению файлы — PDF и изображения (по желанию). Файлы пересылаются письмом
        вместе с заявкой и на сервере сайта не сохраняются.
      </li>
    </ul>
    <p>
      На сайте используется Яндекс Метрика: сведения о посещённых страницах, источнике перехода,
      метках рекламной кампании, действиях на сайте, браузере, устройстве и технических сетевых
      параметрах, включая IP-адрес и cookie-идентификаторы. Вебвизор записывает действия на
      страницах для анализа удобства сайта. Содержимое формы заявки скрыто от записи, вводимые
      значения не передаются в событиях аналитики. Запрет cookie в браузере не ограничивает доступ к
      сайту и отправку заявки.
    </p>
    {/* Сюда ведёт «Подробнее» из уведомления cookie */}
    <p id="cookies">
      Продолжая пользоваться сайтом, посетитель соглашается на обработку файлов cookie, в том числе
      с использованием сервиса Яндекс Метрика. Запретить обработку cookie можно в настройках
      браузера: заблокировать cookie сайта {COMPANY.site} или удалить уже сохранённые. Выбор темы и
      отметка о закрытии уведомления хранятся в браузере. Подробнее — на странице{' '}
      <Link to="/cookies">«Использование файлов cookie»</Link>.
    </p>
    <p>
      На странице контактов размещена интерактивная карта Яндекса. При её загрузке браузер
      обращается к серверам Яндекса; сервис получает сетевые данные и может использовать
      cookie-файлы в соответствии с{' '}
      <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">
        политикой конфиденциальности Яндекса
      </a>
      .
    </p>

    <h2>3. Цели обработки</h2>
    <ul>
      <li>рассмотрение запроса и подготовка коммерческого предложения;</li>
      <li>связь с посетителем по его обращению.</li>
      <li>анализ источников посещений и удобства страниц сайта.</li>
    </ul>
    <p>Персональные данные не используются для рекламных рассылок.</p>

    <h2>4. Правовое основание</h2>
    <p>
      Согласие субъекта персональных данных (п. 1 ч. 1 ст. 6 152-ФЗ), которое посетитель даёт
      отдельно, отмечая согласие в форме. Текст согласия:{' '}
      <Link to="/consent">Согласие на обработку персональных данных</Link>. Согласие на обработку
      cookie, в том числе сервисом Яндекс Метрика, посетитель выражает, продолжая пользоваться
      сайтом после уведомления об использовании cookie; оно не является условием отправки заявки.
    </p>

    <h2>5. Действия с данными и способы обработки</h2>
    <p>
      Сбор, запись, систематизация, накопление, хранение, уточнение, использование, удаление и
      уничтожение — с использованием средств автоматизации и без них.
    </p>
    <p>
      Заявка поступает на сервер Сайта, размещённый в Российской Федерации, и направляется оттуда на
      электронную почту Оператора, которая также обслуживается на территории Российской Федерации. В
      отношении заявок запись, систематизация, накопление и хранение данных ведутся в базах данных,
      находящихся в Российской Федерации; трансграничная передача не осуществляется. Третьим лицам
      данные не передаются, кроме случаев, предусмотренных законом, и использования сервиса
      аналитики в соответствии с разделом 2.
    </p>
    <p>
      Технические сведения о посещениях получает ООО «ЯНДЕКС» посредством сервиса Яндекс Метрика.
      Подробнее об обработке:{' '}
      <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">
        политика конфиденциальности Яндекса
      </a>
      . Запрет cookie в браузере не даёт сервису узнавать посетителя при повторных визитах.
      Требование прекратить обработку и вопросы об уже собранных данных можно направить Оператору по
      указанным контактам.
    </p>

    <h2>6. Сроки обработки и хранения</h2>
    <p>
      До достижения целей обработки, но не дольше 3 лет с момента получения обращения, либо до
      отзыва согласия — в зависимости от того, что наступит раньше. После этого данные удаляются.
    </p>

    <h2>7. Права субъекта персональных данных</h2>
    <p>Посетитель вправе:</p>
    <ul>
      <li>получить сведения об обработке своих персональных данных;</li>
      <li>потребовать уточнения, блокирования или уничтожения данных;</li>
      <li>отозвать согласие на обработку;</li>
      <li>обжаловать действия Оператора в Роскомнадзоре или в суде.</li>
    </ul>
    <p>
      Запросы и отзыв согласия направляются на{' '}
      <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> или по адресу: {COMPANY.address}.
      Оператор отвечает в течение 10 рабочих дней.
    </p>

    <h2>8. Защита данных</h2>
    <p>
      Оператор принимает правовые, организационные и технические меры для защиты персональных данных
      от неправомерного доступа, изменения, распространения и уничтожения: доступ к заявкам имеет
      только Оператор, передача с Сайта идёт по защищённому протоколу HTTPS.
    </p>

    <h2>9. Изменение политики</h2>
    <p>
      Оператор может изменять политику. Актуальная редакция всегда опубликована на этой странице.
    </p>
  </>
);
